import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API, UPLOADS } from "../../config/api";

export default function Profile() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [supplierType, setSupplierType] = useState([]);
  const [supplierList, setSupplierList] = useState([]);
  const [providerRules, setProviderRules] = useState();
  const [showRules, setShowRules] = useState(false);
  const [pendingOption, setPendingOption] = useState("");
  const [agreeChecked, setAgreeChecked] = useState(false);
  const [acceptedRules, setAcceptedRules] = useState([]);
  const [profileImage, setProfileImage] = useState(null);
  const [preview, setPreview] = useState("");
  useEffect(() => {
    fetch("/rules.json")
      .then((res) => res.json())
      .then((data) => setProviderRules(data))
      .catch(console.error);
  }, []);
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
    state: "",
    role: "",
    account_type: "",
    status: "",
    profile_image: "",
    provider_options: [],
  });
  const fetchSupplierTypes = async () => {
    try {
      const res = await fetch(`${API.BASE_URL}/api.php?action=supplier_types`);

      const data = await res.json();

      if (data.status) {
        setSupplierList(data.data);
      }
    } catch (error) {
      console.log("Supplier type error:", error);
    }
  };

  // ================= FETCH PROFILE =================
  const fetchProfile = async () => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (!user) return navigate("/");

    try {
      const res = await fetch(`${API.GET_USER}&id=${user.id}`);
      const data = await res.json();

      if (!data.success) return;

      let provider_options = [];
      let supplier_types = [];

      try {
        provider_options = JSON.parse(data.user?.provider_options || "[]");
      } catch {
        provider_options = [];
      }

      try {
        supplier_types = JSON.parse(data.user?.supplier_types || "[]");
      } catch {
        supplier_types = [];
      }

      setForm((prev) => ({
        ...prev,
        name: data.user?.name || "",
        email: data.user?.email || "",
        phone: data.user?.phone || "",
        city: data.user?.city || "",
        state: data.user?.state || "",
        role: data.user?.role || "",
        account_type: data.user?.account_type || "",
        status: data.user?.status || "",
        profile_image: data.user?.profile_image || "",
        provider_options: Array.isArray(provider_options)
          ? provider_options
          : [],
      }));

      setSupplierType(Array.isArray(supplier_types) ? supplier_types : []);
      setAcceptedRules(
        Array.isArray(provider_options)
          ? provider_options.filter((x) => x !== "visitor")
          : [],
      );
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchProfile();
    fetchSupplierTypes();
  }, []);

  const updateProvider = (value) => {
    setForm((prev) => {
      let updated = [...prev.provider_options];

      if (value === "visitor") {
        updated = updated.includes("visitor") ? [] : ["visitor"];
        setSupplierType([]);
      } else {
        updated = updated.filter((x) => x !== "visitor");

        if (updated.includes(value)) {
          updated = updated.filter((x) => x !== value);

          setAcceptedRules((prevRules) =>
            prevRules.filter((item) => item !== value),
          );

          if (value === "supplier") {
            setSupplierType([]);
          }
        } else {
          updated.push(value);
        }
      }

      return {
        ...prev,
        provider_options: updated,
        account_type:
          updated.includes("visitor") || updated.length === 0
            ? "customer"
            : "provider",
      };
    });
  };
  // ================= HANDLE INPUT =================
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // ================= PROVIDER CHECKBOX =================
  const handleProviderChange = (value) => {
    const alreadySelected = form.provider_options.includes(value);

    if (value === "visitor") {
      updateProvider(value);
      return;
    }

    // Check rules available or not
    const selectedRule = providerRules[value];

    const hasRules =
      selectedRule &&
      ((Array.isArray(selectedRule.rules) && selectedRule.rules.length > 0) ||
        (Array.isArray(selectedRule.sections) &&
          selectedRule.sections.length > 0));

    // If rules exist then show popup
    if (!alreadySelected && hasRules && !acceptedRules.includes(value)) {
      setPendingOption(value);
      setAgreeChecked(false);
      setShowRules(true);
      return;
    }

    // If no rules directly select provider
    updateProvider(value);
  };
  // ================= SUPPLIER CHECKBOX =================
  const handleSupplierTypeChange = (value, checked) => {
    setSupplierType((prev) =>
      checked ? [...prev, value] : prev.filter((x) => x !== value),
    );
  };
  const handleAgreeRules = () => {
    setAcceptedRules((prev) => [...prev, pendingOption]);

    updateProvider(pendingOption);

    setPendingOption("");
    setAgreeChecked(false);
    setShowRules(false);
  };

  const handleCancelRules = () => {
    setPendingOption("");
    setAgreeChecked(false);
    setShowRules(false);
  };
  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setProfileImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };
  // ================= SUBMIT =================
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const user = JSON.parse(sessionStorage.getItem("user"));

    try {
      const fd = new FormData();

      fd.append("id", user.id);
      fd.append("name", form.name);
      fd.append("email", form.email);
      fd.append("phone", form.phone);
      fd.append("city", form.city);
      fd.append("state", form.state);
      fd.append("role", form.role);
      fd.append("account_type", form.account_type);
      fd.append("status", form.status);

      fd.append("provider_options", JSON.stringify(form.provider_options));

      fd.append("supplier_types", JSON.stringify(supplierType));

      if (profileImage) {
        fd.append("profile_image", profileImage);
      }

      const res = await fetch(API.UPDATE_PROFILE, {
        method: "POST",
        body: fd,
      });

      const data = await res.json();
      setLoading(false);

      if (data.success || data.status) {
        const updatedUser = {
          ...user,
          ...form,
          provider_options: form.provider_options,
          supplier_types: supplierType,
        };

        sessionStorage.setItem("user", JSON.stringify(updatedUser));

        window.dispatchEvent(new Event("refreshSidebar"));

        alert("Profile updated successfully");
        navigate(-1);
      } else {
        alert(data.message || "Update failed");
      }
    } catch (err) {
      setLoading(false);
      console.error(err);
      alert("Server error");
    }
  };

  return (
    <div className="profile-overlay" onClick={() => navigate(-1)}>
      <div className="profile-modal" onClick={(e) => e.stopPropagation()}>
        <div className="profile-sidebar1">
          <div className="myprofile-avatar-wrapper">
            <label htmlFor="myProfileUpload" className="myprofile-avatar-label">
              {preview ? (
                <img
                  src={preview}
                  className="myprofile-avatar-image"
                  alt="profile"
                />
              ) : form.profile_image ? (
                <img
                  src={`${UPLOADS.PROFILE_IMAGE}${form.profile_image}`}
                  className="myprofile-avatar-image"
                  alt="profile"
                />
              ) : (
                <div className="myprofile-avatar-letter">
                  {form.name ? form.name.charAt(0).toUpperCase() : "U"}
                </div>
              )}

              <span className="myprofile-edit-button">
                <i className="bi bi-pencil-fill"></i>
              </span>
            </label>

            <input
              id="myProfileUpload"
              type="file"
              accept="image/*"
              hidden
              onChange={handleImageChange}
            />
          </div>
          <div className="badge">{form.account_type || "Customer"}</div>
          <div
            className="badge"
            style={{
              backgroundColor: "#ef4444",
              color: "#fff",
              marginTop: "8px",
            }}
          >
            {form.status || "Active"}
          </div>
        </div>

        <div className="profile-main">
          <header className="profile-header">
            <div>
              <h2>Account Settings</h2>
              {/* <p>
                 Manage your public profile information and vendor configurations 
              </p> */}
            </div>
            <button className="close-icon-btn" onClick={() => navigate(-1)}>
              ✕
            </button>
          </header>

          <form onSubmit={handleSubmit}>
            <div className="form-grid">
              <div className="input-box">
                <label>Full Name</label>
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="input-box">
                <label>Email Address</label>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="input-box readonly">
                <label>Mobile Number</label>
                <input type="text" name="phone" value={form.phone} readOnly />
              </div>

              <div className="input-box readonly">
                <label>Designation / System Role</label>
                <input type="text" name="role" value={form.role} readOnly />
              </div>

              <div className="input-box">
                <label>City</label>
                <input
                  type="text"
                  name="city"
                  value={form.city}
                  onChange={handleChange}
                />
              </div>

              <div className="input-box">
                <label>State</label>
                <input
                  type="text"
                  name="state"
                  value={form.state}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="services-section">
              <span className="section-label">
                What items/services do you provide?
              </span>
              <div className="services-grid">
                {[
                  "visitor",
                  "job_worker",
                  "sketcher",
                  "machines",
                  "designers",
                  "designs",
                  "workspaces",
                  "supplier",
                ].map((opt) => {
                  const isChecked = form.provider_options.includes(opt);
                  return (
                    <div
                      key={opt}
                      className={`service-item ${isChecked ? "selected" : ""}`}
                      onClick={() => handleProviderChange(opt)}
                    >
                      <div
                        className={`checkbox-sign-box ${isChecked ? "checked" : ""}`}
                      >
                        {isChecked && <span className="checkmark-sign">✓</span>}
                      </div>
                      <div className="label">
                        {
                          {
                            visitor: "Visitor / Customer",
                            job_worker: "Job Worker",
                            sketcher: "Sketcher",
                            machines: "Machine Provider",
                            designers: "Designer",
                            designs: "Embroidery Design Seller",
                            workspaces: "Workspace Provider",
                            supplier: "Supplier",
                          }[opt]
                        }
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {form.provider_options.includes("supplier") && (
              <div className="services-section" style={{ marginTop: "25px" }}>
                <span className="section-label">
                  Select Your Supplier Sub-Categories
                </span>

                <div className="services-grid">
                  {supplierList.map((sup) => {
                    const type = sup.type;

                    const isChecked = supplierType.includes(type);

                    return (
                      <div
                        key={sup.id}
                        className={`service-item ${
                          isChecked ? "selected" : ""
                        }`}
                        onClick={() =>
                          handleSupplierTypeChange(type, !isChecked)
                        }
                      >
                        <div
                          className={`checkbox-sign-box ${
                            isChecked ? "checked" : ""
                          }`}
                        >
                          {isChecked && (
                            <span className="checkmark-sign">✓</span>
                          )}
                        </div>

                        <div className="label">{sup.display_name}</div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            <div className="form-footer">
              <button type="submit" className="save-btn" disabled={loading}>
                {loading ? (
                  <span className="loader"></span>
                ) : (
                  "Save Profile Modifications"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
      {showRules && (
        <div
          className="register-popup-overlay"
          onClick={(e) => e.stopPropagation()}
        >
          <div
            className="register-popup-card"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="rules-popup-header">
              <h3>{providerRules[pendingOption]?.title}</h3>

              <button
                type="button"
                className="register-popup-close"
                onClick={handleCancelRules}
              >
                ✕
              </button>
            </div>

            <div className="rules-popup-body">
              <div className="rules-warning">
                <i className="bi bi-exclamation-triangle-fill"></i>
                <span>Please read all rules carefully.</span>
              </div>

              <ul className="rules-list">
                {providerRules[pendingOption]?.sections ? (
                  providerRules[pendingOption].sections.map(
                    (section, sIndex) => (
                      <div key={sIndex} className="rules-section">
                        <h4 className="rules-heading">{section.heading}</h4>

                        <ul>
                          {section.rules.map((rule, rIndex) => (
                            <li key={rIndex}>
                              <i className="bi bi-check-circle-fill"></i>
                              {rule}
                            </li>
                          ))}
                        </ul>
                      </div>
                    ),
                  )
                ) : (
                  <ul>
                    {providerRules[pendingOption]?.rules?.map((rule, index) => (
                      <li key={index}>
                        <i className="bi bi-check-circle-fill"></i>
                        {rule}
                      </li>
                    ))}
                  </ul>
                )}
              </ul>

              <div className="rules-agreement">
                <label>
                  <input
                    type="checkbox"
                    checked={agreeChecked}
                    onChange={(e) => setAgreeChecked(e.target.checked)}
                  />

                  <span>
                    મેં ઉપર લખેલ તમામ શરતો અને નિયમો વાંચ્યા છે અને તેનું પાલન
                    કરવા માટે સંમત છું.
                  </span>
                </label>
              </div>
            </div>

            <div className="rules-popup-footer">
              <button
                type="button"
                className="rules-cancel-btn"
                onClick={handleCancelRules}
              >
                Cancel
              </button>

              <button
                type="button"
                className="rules-agree-btn"
                disabled={!agreeChecked}
                onClick={handleAgreeRules}
              >
                I Agree
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
